import React, { useEffect, useState } from "react";
import EmrVisitsService from "../../../services/EmrVisitsService";

const ActivityChargesList = (props) => {
  const { visit_id ,Headers ,selectedTab, fullWidth = false } = props;
  const [activityData, setActivityData] = useState({ items: [], total_price: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActivityCharges();
  }, [visit_id,Headers,selectedTab]);

  const fetchActivityCharges = async () => {
    setLoading(true);
    try {
      const response = await EmrVisitsService.getActivityCharges(visit_id);
      if (response?.data) {
        setActivityData(response.data);
      }
    } catch (err) {
      console.error("Error fetching activity charges:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={fullWidth ? "w-100" : "col-3"}>
      <div
        className="card sh_basecard cardhtmd"
        style={{ height: "350px", display: "flex", flexDirection: "column" }}
      >
        <div className="card-header p-2 sh_basecardHeader">
          <div className="d-flex w-100 justify-content-between align-items-center">
            <span>Activity Charges</span>
          </div>
        </div>

        {/* Scrollable Table Section */}
        <div
          className="card-body py-2 px-0 sh_basecardBody"
          style={{
            overflowY: "auto",
            flex: 1,
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
        >
          <table className="table sh_tablenew mb-0">
            <thead className="table-light sticky-top">
              <tr>
                <th>Code</th>
                <th>Activity Name</th>
                <th>Charges (USD)</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : activityData.items && activityData.items.length > 0 ? (
                activityData.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.activity_code}</td>
                    <td>{item.activity_name}</td>
                    <td>${parseFloat(item.standard_price).toFixed(2)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No activities found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Fixed Footer */}
        {activityData.total_price ? (
          <div
            className="p-2 border-top bg-light d-flex justify-content-between align-items-center"
            style={{
              position: "sticky",
              bottom: 0,
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            <span>Total Charges</span>
            <span
              style={{
                fontWeight: "900",
                fontSize: "1rem",
                color: "#000",
              }}
            >
              ${parseFloat(activityData.total_price).toFixed(2)}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ActivityChargesList;
